/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Admin_Recipients_RequiredInputs */

const en_mail_admin_recipients_required = /** @type {(inputs: Mail_Admin_Recipients_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select at least one recipient.`)
};

const de_mail_admin_recipients_required = /** @type {(inputs: Mail_Admin_Recipients_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie mindestens einen Empfänger aus.`)
};

/**
* | output |
* | --- |
* | "Please select at least one recipient." |
*
* @param {Mail_Admin_Recipients_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_admin_recipients_required = /** @type {((inputs?: Mail_Admin_Recipients_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Admin_Recipients_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_admin_recipients_required(inputs)
	return en_mail_admin_recipients_required(inputs)
});